import { camelCase } from "lodash-es";

import { useMultiplayerContext } from "../../../hooks/use-multiplayer-context";
import { TranscriptAction } from "../../../providers/transcript-context";
import { Operation, PersistedRevision, Revision } from "../../../types/schemas";

export function useRemoteTranscriptChanges(
  dispatch: (action: TranscriptAction) => void,
): void {
  useMultiplayerContext((message) => {
    if (message.type !== "revision") return;

    // Two differences to convert for revisions from the server vs what the client expects:
    // 1. The parts of operation paths need to be converted to camelCase
    // 2. The shape, including non-primitive values, needs to be converted to camelCase
    const convertedRevision: Revision = {
      ...message.payload,
      operations: message.payload.operations.map((operation) => {
        if ("path" in operation) {
          return {
            ...operation,
            path: operation.path.map((part) =>
              typeof part === "string" && !Number(part)
                ? camelCase(part)
                : part,
            ),
          } as Operation;
        }
        return operation;
      }),
    };

    dispatch({
      type: "serverRevisions",
      revisions: [convertedRevision as PersistedRevision],
    });
  });
}
